import { render, staticRenderFns } from "./SquareOption.vue?vue&type=template&id=09500faa&scoped=true"
import script from "./SquareOption.vue?vue&type=script&lang=js"
export * from "./SquareOption.vue?vue&type=script&lang=js"
import style0 from "./SquareOption.vue?vue&type=style&index=0&id=09500faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09500faa",
  null
  
)

export default component.exports